import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from 'seagull';
import styles from './CommonComponents.module.scss';
export function AgreementViewCard(_0) {
    let { className, children, headTitle } = _0, rest = _object_without_properties(_0, [
        "className",
        "children",
        "headTitle"
    ]);
    return /*#__PURE__*/ _jsxs("section", _object_spread_props(_object_spread({
        className: cn(styles.card, className)
    }, rest), {
        children: [
            headTitle && /*#__PURE__*/ _jsx(SectionTitle, {
                className: styles.sectionTitle,
                children: headTitle
            }),
            children
        ]
    }));
}
export function SectionTitle(_0) {
    let { children } = _0, props = _object_without_properties(_0, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, props), {
        variant: "h5",
        children: children
    }));
}
export function Logo(param) {
    let { logoUrl } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.logoContainer,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.circle,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.logoImageBorder
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.logoImageContainer,
                    style: {
                        backgroundImage: "url(".concat(logoUrl, ")")
                    }
                })
            ]
        })
    });
}
export function TopStripe(param) {
    let { backgroundColor } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.topStripe,
        style: {
            backgroundColor
        }
    });
}
export function SpecificTerm(props) {
    const { field, value, testId, changes } = props;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                weight: "bold",
                children: field
            }),
            /*#__PURE__*/ _jsx(Typography, {
                testId: testId,
                children: value
            }),
            changes && /*#__PURE__*/ _jsx("div", {
                className: styles.changes,
                children: changes
            })
        ]
    });
}
